import { render, staticRenderFns } from "./settingLearning.vue?vue&type=template&id=288a0048&scoped=true"
import script from "./settingLearning.vue?vue&type=script&lang=js"
export * from "./settingLearning.vue?vue&type=script&lang=js"
import style0 from "./settingLearning.vue?vue&type=style&index=0&id=288a0048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a0048",
  null
  
)

export default component.exports